import { render, staticRenderFns } from "./TrafficInformation.vue?vue&type=template&id=4f5898ce&scoped=true&"
import script from "./TrafficInformation.vue?vue&type=script&lang=js&"
export * from "./TrafficInformation.vue?vue&type=script&lang=js&"
import style0 from "./TrafficInformation.vue?vue&type=style&index=0&id=4f5898ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5898ce",
  null
  
)

export default component.exports